/**
 * The Fast Familiar mark. Inlined rather than loaded as a file so it inherits
 * `currentColor` and can be tinted to whatever the surrounding page needs.
 */
export function FastFamiliarLogo({
  className,
  title = "Fast Familiar",
}: {
  className?: string;
  title?: string;
}): React.ReactElement {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 397.32 303.93"
      fill="currentColor"
      role="img"
      aria-label={title}
    >
      <title>{title}</title>
      <path d="M397.32,174.2c-21.05,12.72-41.76,25.25-62.58,37.85l-72.35-29.29-52.68,31.55,72.65,29.38L227,277.17l-72.82-29.42-45.7,27.45V228.33l45-27.09v-23.8l102.65-60.63Z" />
      <path d="M57.38,83.35V303.93L0,280.91V59.1L98.13,0l58,23.85Z" />
      <path d="M108,168.94V124.39l46.12,17.94Z" />
    </svg>
  );
}
